<template>
  <ul class="sidebar-nav">
    <li class="nav-item" v-for="menu in menus" :key="menu.routeName">
      <!-- @clickで親にクリックイベントを通知 -->
      <router-link 
        :to="{ name: menu.routeName }" 
        class="nav-link" 
        :class="{ active: isActive(menu.group) }"
        @click="onMenuClick(menu.routeName)"
      >
        <img class="mx-3" :src="'/img/icon/nav-' + menu.icon + '.png'" :alt="menu.icon">
        <span class="fw-bold">{{ menu.displayName }}</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: "MenuList",
  props: {
    menus: {
      type: Array,
      required: true,
    }
  },
  emits: ['menu-click'], // menu-click イベントを明示的に宣言
  methods: {
    isActive(group) {
      return this.$store.state.pageGroup === group;
    },
    onMenuClick(routeName) {
      // 親コンポーネントにクリックイベントとrouteNameを通知
      this.$emit('menu-click', routeName);
    }
  }
}
</script>